import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchArticles, fetchArticle } from "../lib/api";

export function News() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchArticles({ limit: 50 }).then(setItems).catch(() => {});
  }, []);
  return (
    <div data-testid="news-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <div className="overline text-[#B79C7B] mb-3">Editorial</div>
      <h1 className="font-serif text-5xl text-ivory">News & Reflections</h1>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((a) => (
          <Link key={a.id} to={`/news/${a.slug}`} className="group border border-[#2A2A2D] hover:border-[#B79C7B]/60 transition-colors block" data-testid={`news-card-${a.slug}`}>
            <div className="aspect-[16/10] bg-[#1A1A1D] overflow-hidden">
              {a.cover && <img src={a.cover} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
            </div>
            <div className="p-6">
              <div className="overline text-[#71717A] mb-2">{new Date(a.published_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })}</div>
              <div className="font-serif text-xl text-ivory group-hover:text-[#B79C7B] transition-colors leading-tight">{a.title}</div>
              <p className="text-sm text-[#A1A1AA] mt-3 line-clamp-3">{a.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function NewsDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  useEffect(() => {
    fetchArticle(slug).then(setArticle).catch(() => {});
  }, [slug]);
  if (!article) return <div className="max-w-[800px] mx-auto px-6 py-20 text-[#71717A]">Loading…</div>;
  return (
    <div data-testid="news-detail-page">
      <div className="relative h-[55vh]">
        {article.cover && <img src={article.cover} alt="" className="w-full h-full object-cover opacity-50" />}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0A0A0B]/60 to-[#0A0A0B]" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-[900px] mx-auto px-6 lg:px-10 pb-12 w-full">
            <Link to="/news" className="overline text-[#B79C7B] hover:text-ivory">← All articles</Link>
            <h1 className="font-serif text-4xl lg:text-6xl text-ivory mt-6 leading-[1.05] text-balance">{article.title}</h1>
            <div className="overline text-[#71717A] mt-4">By {article.author} · {new Date(article.published_at).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })}</div>
          </div>
        </div>
      </div>
      <article className="max-w-[760px] mx-auto px-6 lg:px-10 py-16 prose-invert">
        {article.excerpt && <p className="font-serif text-2xl text-ivory italic leading-relaxed mb-10">{article.excerpt}</p>}
        {article.body.split(/\n+/).map((p, i) => (
          <p key={i} className="text-[#F4F0EA] text-lg leading-relaxed mb-6">{p}</p>
        ))}
      </article>
    </div>
  );
}
